module.exports = __webpack_public_path__ + "img/goPt.951411b3.png";